









































































































































import dayjs from "dayjs";
import { defineComponent, PropType, ref } from "@vue/composition-api";
import OccLabel from "@/components/Atoms/OccLabel/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccStar from "@/components/Atoms/OccStar/index.vue";
import ListTable from "@/components/Molecules/ListTable/index.vue";
import {
  getDisplayEventStatus,
  getDisplayEventType,
  getDisplaySelectionStatus
} from "@/helpers/partnerEntryUsers";
import { ApiResponse, Order } from "@/api/types";

export interface Props {
  roundtableAttendees: ApiResponse.RoundtableAtendees[];
}

export default defineComponent({
  name: "RoundtableUsersTable",
  components: {
    OccLabel,
    OccButton,
    OccStar,
    ListTable
  },
  props: {
    roundtableAttendees: {
      type: Array as PropType<Props["roundtableAttendees"]>,
      default: () => []
    },
    selectedPartnerEntryUsers: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hasAlert: {
      type: Boolean,
      default: false
    }
  },
  emits: ["onChangeOrder"],
  setup(_, { emit }) {
    const partnerEntryUserIds = ref<number[]>([]);

    const handleChangeRowValue = (rowValues: number[]) => {
      partnerEntryUserIds.value = rowValues;
    };

    const formatDate = (date: string, withTime = false) => {
      if (!date) {
        return;
      }

      return dayjs(date).format(withTime ? "YYYY/MM/DD HH:mm" : "YYYY/MM/DD");
    };

    const getDisplayScheduleSpan = (date: { start: string; end: string }) => {
      if (date.start && date.end) {
        return `${formatDate(date.start)}〜${formatDate(date.end)}`;
      } else if (date.start) {
        return formatDate(date.start);
      } else {
        return formatDate(date.end);
      }
    };

    const onChangeOrder = (order: Order, headerIndex: number) => {
      emit("onChangeOrder", order, headerIndex);
    };

    return {
      getDisplayEventStatus,
      getDisplayEventType,
      getDisplaySelectionStatus,
      getDisplayScheduleSpan,
      formatDate,
      handleChangeRowValue,
      onChangeOrder
    };
  }
});
